<!--命令提示-->
<template>
  <el-tooltip v-if="tip" :show-after="1000" placement="top">
    <el-badge
      v-if="badgeText"
      class="ey-badge"
      :value="badgeText"
      :type="badgeType"
    >
      <slot />
    </el-badge>
    <slot v-else />

    <template #content>
      <pre class="tip">{{ tip }}</pre>
      <span v-if="detail" class="detail" @click="showDetail">&nbsp;详见</span>
    </template>
  </el-tooltip>

  <template v-else>
    <el-badge
      v-if="badgeText"
      class="ey-badge"
      :value="badgeText"
      :type="badgeType"
    >
      <slot />
    </el-badge>
    <slot v-else />
  </template>
</template>

<script lang="ts" setup>
/**
 * ### 菜单提示组件
 * 当菜单项中有 help/tip/info 属性时该组件生效
 * <warning> 该组件应作为按钮内部组件使用 外部应该用不到
 */
import { ElTooltip, ElBadge } from 'element-plus';

defineProps<{
  /**
   * ### table名
   * <warning> 应该是无用属性 待确认后删除
   */
  table: string;
  /**
   * ### cmd id
   * <warning> 应该是无用属性 待确认后删除
   */
  index: string;
  /**
   * ### 提示文案
   */
  tip?: string;
  /**
   * ### 帮助详情文案
   */
  detail?: boolean;
  /**
   * ### 徽章文案
   */
  badgeText?: string;
  /**
   * ### 徽章类型
   */
  badgeType?: 'success' | 'warning' | 'info' | 'primary' | 'danger';
}>();

function showDetail() {
  alert('help');
}
</script>

<style lang="scss" scoped>
.detail {
  color: #a1c0ef;
  cursor: pointer;
}

.tip {
  display: inline;
}

.ey-badge {
  :deep(.el-badge__content) {
    zoom: 0.8;
    right: 0 !important;
    transform: translateY(-50%) translateX(0%) !important;
  }
}
</style>
